export default "__VITE_ASSET__raXNjN_G__"